// extracted by mini-css-extract-plugin
export var content = "layout-module--content--K-wVB";
export var content1 = "layout-module--content1--0FvAm";
export var content2 = "layout-module--content2--6kSZY";
export var content3 = "layout-module--content3--rX6WK";